import { render } from "./CookieTest.vue?vue&type=template&id=cc61631e&scoped=true"
import script from "./CookieTest.vue?vue&type=script&lang=js"
export * from "./CookieTest.vue?vue&type=script&lang=js"

import "./CookieTest.vue?vue&type=style&index=0&id=cc61631e&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc61631e"]])

export default __exports__